module.exports = __webpack_public_path__ + "img/story048@2x.772f2432.png";